// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SleIp","alignToEdge":"iO-8Z","buttonIcon":"ZiZ9X","buttonCaption":"n8LC7","buttonSpacer":"iFGkC"};